import { IAgentHierarchyInformation } from "../../../../../../../../../../agentDetail.model";

export const findHierarchyNode = (
    nodes: IAgentHierarchyInformation[],
    userId: number
): IAgentHierarchyInformation | null => {
    for (const node of nodes) {
        if (node.userId === userId) return node;
        const found = findHierarchyNode(node.downLine, userId);
        if (found) return found;
    }
    return null;
};
